const initialState = {
    userDetails: null, 
    activeChat:null // Add this line to your initial state
};

export const Chat = (state = initialState, action) => {
  switch (action.type) {

    case "SET_SELECTED_CHAT": {  // Add this case to handle the new action
      return {
        ...state,
        userDetails: action.payload,
      };
    }
      case "RETRIEVE_ALL_DATA": {  // Add this case to handle the new action
      return {
        ...state,
        allConversation: action.payload,
      };
    }
  case "SET_SELECTED_ACTIVE": {  // Add this case to handle the new action
      return {
        ...state,
        activeChat: action.payload,
      };
    }
    default:
      return state;
  }
};
export default Chat;